// extracted by mini-css-extract-plugin
var _1 = "PageWidgetsContainer-modulecontent__bdRGe";
var _2 = "PageWidgetsContainer-modulescrollWrapper__jU8ya";
var _3 = "PageWidgetsContainer-modulewidgetsContainer__YTrH8";
var _4 = "PageWidgetsContainer-modulewidgetsContent__tbLUH";
export { _1 as "content", _2 as "scrollWrapper", _3 as "widgetsContainer", _4 as "widgetsContent" }
